import { AlertTriangle } from "lucide-react";

export const DuplicateNotice = ({ notice, label, onKeep, onUndo, busy }) => {
  if (!notice) return null;
  return (
    <div data-testid="door-duplicate-warning" role="alert" className="rounded-xl border border-amber-200 bg-amber-50 px-4 py-3 text-sm text-amber-900">
      <p className="flex items-start gap-2 font-semibold">
        <AlertTriangle className="mt-0.5 h-4 w-4 shrink-0" />
        <span>A guest named “{notice.guest.identifier}” already exists. Keep both?</span>
      </p>
      <p className="mt-1 pl-6 text-xs text-amber-800">
        {notice.duplicates.length + 1} guests now share this {label.toLowerCase()}. They stay separate entries.
      </p>
      <div className="mt-3 flex gap-2 pl-6">
        <button type="button" data-testid="door-duplicate-keep" onClick={onKeep} className="min-h-[40px] rounded-lg bg-amber-600 px-4 text-sm font-semibold text-white hover:bg-amber-700">Keep both</button>
        <button type="button" data-testid="door-duplicate-undo" disabled={busy} onClick={onUndo} className="min-h-[40px] rounded-lg border border-amber-300 bg-white px-4 text-sm font-semibold text-amber-900 hover:bg-amber-100 disabled:opacity-50">Undo add</button>
      </div>
    </div>
  );
};
